<template>
  <div class="fl-sym-px-4">
    <div class="fl-sym-mt-5 xs:fl-sym-mt-8 fl-sym-text-primary fl-sym-text-xxs">
      VERIFY PASSWORD
    </div>
    <div
      class="fl-sym-text-black fl-sym-text-5xl fl-sym-leading-tight fl-sym-font-semibold fl-sym-mb-2"
    >
      Verify your email
    </div>
    <div class="fl-sym-text-intermediate fl-sym-text-lg">
      An email has been sent to your email address, please click on the link in the email to continue.
    </div>

    <form
      class="fl-sym-mt-16 xnpms:fl-sym-mt-12"
      @submit.prevent="submit"
      method="post"
    >
      <div class="fl-sym-mt-8 xs:fl-sym-mt-40 fl-sym-mb-2">
        <button
          type="submit"
          class="fl-sym-bg-primary fl-sym-rounded-full fl-sym-text-white fl-sym-p-3 fl-sym-w-full fl-sym-text-sm"
        >
          Login
        </button>
      </div>
      <div class="fl-sym-flex fl-sym-justify-center fl-sym-text-sm">
        <div class="fl-sym-text-primary" style="cursor: pointer" @click="back">
          Back
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState({
      user: state => state.auth.user,
      errors: state => state.auth.errors
    })
  },
  methods: {
    back() {
      this.$router.go("-1");
    },
    submit: function () {
      // TODO: test this works and add a button to resend verification email if required
      this.$router.push({name: process.env.VUE_APP_AUTH_LOGIN})
      //this.$store.dispatch('auth/Login')
    },
  },
};
</script>
<style>
.error {
  top: 460px;
  left: 20px;
  width: 366px;
  height: 16px;
  letter-spacing: var(--unnamed-character-spacing-0);
  text-align: left;
  letter-spacing: 0px;
  opacity: 1;
  font: "SFProDisplay-Regular";
  font-size: 16px;
  color: #ff3a19;
}

border-red {
  border-color: #ff3a19;
}
</style>